import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as recommendationAction from '../../../../actions/recommendationAction';
import Recommandation from './Recommendation';

const mapStateToProps = state => {
    return {
        recommendationState: state.recommendationReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRecommendationAction: (filters) => dispatch(recommendationAction.getRecommendationAction(filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Recommandation));
